module.exports = __webpack_public_path__ + "static/media/beach.b45514ed.svg";